import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../../localization'
import useStyles from './styles/MonitoringFormListTableHead.styles'

interface MonitoringFormListTableHeadMobileProps {}
const MonitoringFormListTableHeadMobile: React.FC<
  MonitoringFormListTableHeadMobileProps
> = ({}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">{getTranslate('Endpoint Name')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Status')}</Typography>
      </div>
      <div>
        <IconButton>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}
export default MonitoringFormListTableHeadMobile
